export default __webpack_public_path__ + "static/banner-4cdd3abe532256974465996bce3eadb1.webp";